import translation from '../../locales/messages';
import { DEFAULT_LOCALE, flattenMessages } from '../../locales/utils';
import { UPDATE_LOCALE } from '../types';

export const initialState = {
  locale: DEFAULT_LOCALE,
  messages: flattenMessages(translation[DEFAULT_LOCALE]),
};

export default (state, action) => {
  state = state || initialState;

  if (action.type === UPDATE_LOCALE) {
    return {
      ...state,
      locale: action.locale,
      messages: flattenMessages(translation[action.locale]),
    };
  } else {
    return state;
  }
};
